export default __webpack_public_path__ + "static/media/tamara sport.f1c07821.jpeg";